<template>
    <div>
        <!-- <button class="btn btn-primary" v-on:click.prevent="closePanel">Close Panel</button> -->
        <div class="onglets flex justify-center">
            <div @click="actif = 1" class="onglet" :class="{active : actif == 1}">
                <i class="fas fa-crown"></i>
                <p>Quete principale</p>
            </div>
            <div @click="actif = 2" class="onglet" :class="{active : actif == 2}">
                <i class="fas fa-hat-wizard"></i>
                <p>Quete secondaire</p>
            </div>
        </div>
        <div class="contenu" v-if="actif == 1">
            <h1>Quest Principale</h1>
            <p>Discutez pour gagner des points et débloquer des récompenses !</p>
            <div class="list-group mt-6">
                <div class="list-group-item" v-for="item in main" :key="item.item">
                    <div class="media mb-4 pb-4 dashed-space-1px">
                        <div class="media-left mr-4">
                            <i class="fas fa-crown mt-2"></i>
                        </div>
                        <div class="media-body">
                            <h4 class="font-bold text-lg media-heading">{{ item.name }}</h4>
                            <span class="text-xs notification-location">{{ item.description }}</span>
                            <p class="text-xs text-right">xp : {{ xp }}/ {{ item.xp }}</p>
                            <div class="progressBar">
                                <div
                                    class="progressBarContent"
                                    :style="{width: xpPourcent(item.xp) + '%'}"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <hr>
                </div>
            </div>
        </div>

        <div class="contenu" v-if="actif == 2">
            <h1>Quest Secondaire</h1>
            <p>Dépensez les points durement gagné pour débloquer d'autres récompenses</p>
            <p class="mt-4 font-bold">Vous avez encore : {{ gold }} points</p>
            <div class="list-group mt-6">
                <div class="list-group-item" v-for="item in second" :key="item.item">
                    <div class="media mb-4 pb-4 dashed-space-1px">
                        <div class="media-left mr-4">
                            <i class="fas fa-hat-wizard mt-2"></i>
                        </div>
                        <div class="media-body">
                            <h4 class="font-bold text-lg media-heading">{{ item.name }}</h4>
                            <span class="text-xs notification-location">{{ item.description }}</span>
                            <div class="text-xs">prix: {{ item.price }} points</div>
                        </div>
                        <button
                            disabled
                            v-if="item.have"
                            class="text-xs notification-time rounded-full py-2 px-4 bouton buy openSans font-bold"
                        >Déjà acheté</button>
                        <button
                            @click="buy(item.id)"
                            v-else
                            class="text-xs notification-time rounded-full py-2 px-4 bouton openSans font-bold"
                        >Achete le !</button>
                    </div>
                    <hr>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Quests",
    data() {
        return {
            actif: 1,
            xp: 0,
            gold: 0,
            main: [],
            second: [],
            error: null,
            idConvo: undefined
        };
    },
    props: {
        today: { type: Boolean, required: false, default: false }
    },
    mounted() {
        if (this.today) {
            this.callToday();
        } else {
            this.idConvo = this.$route.params.id;
            this.callQuest();
        }
    },
    methods: {
        callQuest() {
            this.axios
                .get("/api/conversations/" + this.idConvo + "/quests")
                .then(response => {
                    if (response.status == 200) {
                        this.xp = response.data.xp;
                        this.gold = response.data.gold;
                        this.main = response.data.main;
                        this.second = response.data.second;
                    }
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        },
        callToday() {
            this.axios
                .get("/api/conversations/today")
                .then(response => {
                    if (response.status == 200) {
                        this.idConvo = response.data.data.id;
                        this.callQuest();
                    }
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        },
        buy(item) {
            this.axios
                .post("/api/conversations/" + this.idConvo + "/purchases", {
                    item_id: item
                })
                .then(response => {
                    this.callQuest();
                })
                .catch(errors => {
                    this.error = errors.error;
                });
        },
        xpPourcent(xpGoal) {
            let value = (this.xp * 100) / xpGoal;
            if (value > 100) return 100;
            else return value;
        },
        closePanel() {
            this.$emit("closePanel", {});
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.onglet {
    width: 40%;
    font-size: 1.3em;
    padding: 2% 5%;
    float: left;
    color: black;
    text-align: center;
}
.active {
    i,
    p {
        color: rgba(79, 0, 182, 0.7);
    }
}

.contenu {
    clear: both;
    padding: 2%;
    text-align: center;

    .list-group {
        position: relative;
        width: 100%;
    }

    .media {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background-color: rgba(255, 255, 255, 0.2);
        padding: 10px 10px 20px 10px;
        max-height: 100px;
        text-align: left;
    }

    .media-left img {
        height: 50px;
        max-width: 50px;
        width: 50px;
        border-radius: 50%;
    }

    .media-heading {
        margin-top: 0;
        margin-bottom: 5px;
    }
    .media-body {
        width: 100%;
    }

    .progressBar {
        width: 100%;
        background-color: rgba(79, 0, 182, 0.5);
        height: 10px;
    }

    .progressBar .progressBarContent {
        background-color: #4600b6;
        height: 100%;
    }

    .bouton {
        background-color: #4600b6;
        color: white;
        width: 40%;
        max-height: 35px;

        &.buy {
            background-color: rgba(79, 0, 182, 0.5);
        }
    }
}
</style>
